/* ===========================================================================
   HEIDI — Blog : sommaire, ancres, progression de lecture.

   Tout est en amélioration progressive. Sans JavaScript l'article reste
   entièrement lisible : le sommaire est simplement absent (il part avec
   l'attribut `hidden`) et la barre de progression reste à zéro.

   Le sommaire est construit ici et non en Liquid parce que Liquid ne sait pas
   parcourir le HTML du champ de contenu : il faudrait découper des chaînes,
   et les titres n'y portent aucun identifiant.
   =========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Identifiant stable et lisible, dérivé du texte du titre. */
  function slugify(text) {
    return text
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')   // diacritiques
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60) || 'section';
  }

  function initToc() {
    var nav = document.querySelector('[data-hs-toc]');
    var list = document.querySelector('[data-hs-toc-list]');
    var body = document.querySelector('[data-hs-article-body]');
    if (!nav || !list || !body) return;

    var headings = Array.prototype.slice.call(body.querySelectorAll('h2, h3, h4'));

    /* Sous trois titres, un sommaire encombre plus qu'il n'aide. */
    if (headings.length < 3) return;

    /* Le corps reel n'utilise que des h3, sans aucun h2. On retient le niveau le
       plus haut present et on le traite comme niveau de section : sinon tout le
       sommaire serait indente sans parent, et le style de section ne sortirait
       jamais. Le CSS lit data-heading-depth. */
    var topLevel = headings.reduce(function (min, h) {
      var n = parseInt(h.tagName.slice(1), 10);
      return n < min ? n : min;
    }, 6);
    body.setAttribute('data-heading-depth', String(topLevel));

    var used = Object.create(null);
    var links = [];

    headings.forEach(function (h) {
      var text = (h.textContent || '').trim();
      if (!text) return;

      if (!h.id) {
        var base = slugify(text);
        var id = base;
        var n = 2;
        while (used[id] || document.getElementById(id)) { id = base + '-' + n; n++; }
        h.id = id;
      }
      used[h.id] = true;

      var li = document.createElement('li');
      var lvl = parseInt(h.tagName.slice(1), 10);
      li.setAttribute('data-level', lvl === topLevel ? 'top' : '3');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = text;
      li.appendChild(a);
      list.appendChild(li);
      links.push({ a: a, el: h });

      /* Ancre copiable sur le titre lui-même. */
      var anchor = document.createElement('a');
      anchor.className = 'hs-anchor';
      anchor.href = '#' + h.id;
      if (nav.dataset.anchorLabel) anchor.setAttribute('aria-label', nav.dataset.anchorLabel);
      anchor.textContent = '#';
      h.appendChild(anchor);
    });

    if (!links.length) return;
    nav.hidden = false;

    /* Titre courant. rootMargin décale la zone de détection sous l'en-tête. */
    if ('IntersectionObserver' in window) {
      var current = null;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var match = links.filter(function (l) { return l.el === entry.target; })[0];
          if (!match || match === current) return;
          if (current) current.a.removeAttribute('aria-current');
          match.a.setAttribute('aria-current', 'true');
          current = match;
        });
      }, { rootMargin: '-80px 0px -70% 0px', threshold: 0 });
      links.forEach(function (l) { io.observe(l.el); });
    }
  }

  function initProgress() {
    var bar = document.querySelector('[data-hs-progress]');
    var body = document.querySelector('[data-hs-article-body]');
    if (!bar || !body) return;

    var ticking = false;

    function update() {
      ticking = false;
      var rect = body.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      if (total <= 0) { bar.style.inlineSize = '0'; return; }
      var seen = Math.min(Math.max(-rect.top, 0), total);
      bar.style.inlineSize = ((seen / total) * 100).toFixed(2) + '%';
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function init() {
    initToc();
    if (!reduceMotion) initProgress();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ===========================================================================
   Barre d'actions : copier le lien, imprimer.

   Les deux boutons partent avec l'attribut `hidden` et ne sont reveles qu'ici.
   Sans JavaScript ils n'apparaissent donc pas, plutot que d'etre presents et
   inertes. Le lien LinkedIn, lui, est un vrai lien : il fonctionne sans JS et
   reste visible.
   =========================================================================== */
(function () {
  'use strict';

  function initActions() {
    var wrap = document.querySelector('[data-hs-actions]');
    if (!wrap) return;

    var copy = wrap.querySelector('[data-hs-copy]');
    if (copy && navigator.clipboard && window.isSecureContext) {
      copy.hidden = false;
      var label = copy.querySelector('[data-hs-copy-label]');
      var original = label ? label.textContent : '';
      copy.addEventListener('click', function () {
        navigator.clipboard.writeText(window.location.href).then(function () {
          if (!label) return;
          label.textContent = copy.dataset.copied || original;
          copy.setAttribute('data-hs-copied', '');
          window.setTimeout(function () {
            label.textContent = original;
            copy.removeAttribute('data-hs-copied');
          }, 2000);
        }).catch(function () { /* refus du presse-papiers : on ne fait rien */ });
      });
    }

    var print = wrap.querySelector('[data-hs-print]');
    if (print && typeof window.print === 'function') {
      print.hidden = false;
      print.addEventListener('click', function () { window.print(); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initActions);
  } else {
    initActions();
  }
})();
